import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  SearchUsersInChatRequest,
  SearchUsersInChatRequestSchema,
} from '../types/chat/chat_requests_pb';
import { SearchUsersInChatResponse } from '../types/chat/chat_responses_pb';
import {
  SearchMessagesRequest,
  SearchMessagesRequestSchema,
} from '../types/message/message_requests_pb';
import { SearchMessagesResponse } from '../types/message/message_responses_pb';
import { GlobalSearchRequest, GlobalSearchRequestSchema } from '../types/search/search_requests_pb';
import { GlobalSearchResponse } from '../types/search/search_responses_pb';
import { WsRequest } from './request.types';

export function globalSearchRequest(
  data: WsRequest<GlobalSearchRequest>
): Promise<GlobalSearchResponse> {
  return wsAppRequestManager.request<GlobalSearchResponse>({
    case: 'globalSearch',
    value: create(GlobalSearchRequestSchema, data),
  });
}

export function searchMessagesRequest(
  data: WsRequest<SearchMessagesRequest>
): Promise<SearchMessagesResponse> {
  return wsAppRequestManager.request<SearchMessagesResponse>({
    case: 'searchMessages',
    value: create(SearchMessagesRequestSchema, data),
  });
}

export function searchUsersInChatRequest(
  data: WsRequest<SearchUsersInChatRequest>
): Promise<SearchUsersInChatResponse> {
  return wsAppRequestManager.request<SearchUsersInChatResponse>({
    case: 'searchUsersInChat',
    value: create(SearchUsersInChatRequestSchema, data),
  });
}
